import React, { useContext, useRef, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import SupplierContext from "context/SupplierContext";
import Select, { Options } from "react-select";
import ProductImagePicker from "../admin-panel/ProductImagePicker.tsx";
import logo from "../../assets/images/background.png";
import { translateToReactSelect } from "utils/KHelperFunctions";
import { translateToProductReactSelect } from "utils/helperFunctions.js";
import "./EditProductModal.scss";
import { connection } from "../../utils/apiConnection.ts";
import toast from "react-hot-toast";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

export default function EditProductModal({
  // product,
  // setProduct,
  setUpdater1,
  updater1
}) {
  const [updater, setUpdater] = useState(false);

  const { product } = useContext(SupplierContext);
  const [selectedProduct, setSelectedProduct] = useState({ ...product });
  useEffect(() => {
    console.log("producttttt", product);
    if (product) {
      setSelectedProduct(product);
    }
    setSelectedProduct(prev => {
      let temp = { ...prev };
      temp.info.priceWithDiscount =
        +selectedProduct.info.price - +selectedProduct.info.discount;
      return temp;
    });
    console.log("priceWithDiscount", selectedProduct.info.priceWithDiscount);
  }, [product]);

  console.log("selected producttttt", selectedProduct);
  const [selectedOption, setSelectedOption] = useState(
    JSON.parse(product.info.available_order_option_ids)
  );

  const [imgSupplier, setImgSupplier] = useState({});

  function productImageHandler(names, value) {
    setSelectedProduct(prev => {
      let temp = { ...prev.info };
      temp = { ...temp, [names]: URL.createObjectURL(value) };
      return { ...selectedProduct, info: temp };
    });
  }
  function sendImage(value) {
    setImgSupplier(value);
  }
  function inputChangeHandler(event: Event, isNumber: boolean = false) {
    let value: string = event.target.value,
      name: string = event.target.name;
    try {
      if (isNumber) {
        value = removeCommas(value);
        if (isNaN(value)) {
          throw new Error("لطفا عدد را به درستی وارد نمایید.");
        }
        value = +value;
      }
      let tName = name.toLowerCase();

      if (tName === "pricewithdiscount" && selectedProduct.info.price < value)
        throw new Error("تخفیف نمیتواند از قیمت بیشتر باشد.");
      if (tName === "price" && selectedProduct.info.priceWithDiscount > value)
        throw new Error("قیمت نمیتواند از تخفیف کمتر باشد.");

      if (
        tName === "min_order_count" &&
        selectedProduct.info.total_inventory_count < value
      )
        throw new Error("حداقل سفارش نمیتواند از موجودی بیشتر باشد.");
      if (
        tName === "total_inventory_count" &&
        selectedProduct.info.min_order_count > value
      )
        throw new Error("موجودی نمیتواند از حداقل سفارش کمتر باشد.");

      if (tName === "weight_from" && selectedProduct.info.weight_to < value)
        throw new Error("حداقل وزن نمیتواند از حداکثر وزن بیشتر باشد.");
      if (
        tName === "weight_to" &&
        value != 0 &&
        selectedProduct.info.weight_from > value
      )
        throw new Error("حداکثر وزن نمیتواند از حداقل وزن کمتر باشد.");

      setSelectedProduct(prev => {
        let temp = { ...prev.info };
        temp = { ...temp, [name]: value };
        return { ...selectedProduct, info: temp };
      });
    } catch (ex) {
      toast.error(ex.message);
    }
  }

  function checkBoxHandler(index, event: Event | undefined) {
    if (event) {
      let price = event.target.value;
      if (!isNaN(price)) {
        setSelectedOption(prev =>
          prev.map((v, i) => {
            if (i == index) return { ...v, default_price: +price };
            return v;
          })
        );
      } else {
        toast.error("لطفا عدد را به درستی وارد نمایید.");
      }
    } else {
      setSelectedOption(prev =>
        prev.map((v, i) => {
          if (i == index) return { ...v, status: !v.status };
          return v;
        })
      );
    }
  }

  function checkBoxHandler1(index, event: Event | undefined) {
    if (event) {
      let time = event.target.value;
      if (!isNaN(time)) {
        setSelectedOption(prev =>
          prev.map((v, i) => {
            if (i == index) return { ...v, default_need_time: +time * 60 };
            return v;
          })
        );
      } else {
        toast.error("لطفا عدد را به درستی وارد نمایید.");
      }
    } else {
      setSelectedOption(prev =>
        prev.map((v, i) => {
          if (i == index) return { ...v, status: !v.status };
          return v;
        })
      );
    }
  }
  const [validationProduct, setValidationProduct] = useState({
    price: true,
    weightFrom: true,
    weightTo: true,
    productId: true,
    inventory: true
    // checkWeight: true
  });
  const validation = () => {
    let isValid = true;
    if (selectedProduct.info.price == "") {
      setValidationProduct(prev => {
        return { ...prev, price: false };
      });
      isValid = false;
    } else {
      setValidationProduct(prev => {
        return { ...prev, price: true };
      });
    }

    if (selectedProduct.info.total_inventory_count == "") {
      setValidationProduct(prev => {
        return { ...prev, inventory: false };
      });
      isValid = false;
    } else {
      setValidationProduct(prev => {
        return { ...prev, inventory: true };
      });
    }

    return isValid;
  };

  function submitForm() {
    // document.querySelector("#editProductBtn").disabled = true;
    connection("supplier/edit_product_supplier", {
      avb_pid: selectedProduct.info.avb_product_for_order__id,

      price: selectedProduct.info.price,
      discount:
        selectedProduct.info.price - selectedProduct.info.priceWithDiscount,

      img_cover_files_id: imgSupplier,

      new_inventory: selectedProduct.info.total_inventory_count,
      min_order_count: selectedProduct.info.min_order_count,
      weight_from: selectedProduct.info.weight_from,
      weight_to: selectedProduct.info.weight_to,
      selected_aoos: JSON.stringify(selectedOption)
    }).then(data => {
      if (data.status == 1) {
        setUpdater1(!updater1);
        toast.success("محصول با موفقیت ویرایش شد.");
        document.querySelector("#editProductModal .btn-close").click();
      } else {
        toast.error("مشکلی در ویرایش محصول به وجود آمد");
        document.querySelector("#editProductBtn").disabled = false;
      }
    });
    // console.log("show form data: ");
    // for (var [key, value] of formData1.entries()) {
    //   console.log(key, value);
    // }
  }

  return (
    <div
      className="modal fade"
      id="editProductModal"
      tabIndex="-1"
      aria-labelledby="editProductModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg ">
        <div className="modal-content">
          <div className="modal-header">
            <h5>ویرایش کالا</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body ">
            <div className="edit-product">
              <form className="">
                <div>
                  {selectedProduct && (
                    <div className="d-flex justify-content-center">
                      <ProductImagePicker
                        className="mx-3"
                        productImageHandler={(x, e) => {
                          productImageHandler("supplier_cover_img", e);
                          sendImage(e);
                        }}
                        index={0}
                        src={
                          imgSupplier.length > 0
                            ? URL.createObjectURL(imgSupplier)
                            : selectedProduct.info.supplier_cover_img
                        }
                        type={true}
                      />

                      <span style={{ width: "20px" }}></span>
                      {selectedProduct.info.product_cover_img && (
                        <ProductImagePicker
                          src={selectedProduct.info.product_cover_img}
                          index={1}
                          type={false}
                          productImageHandler={() => {}}
                        />
                      )}
                    </div>
                  )}
                </div>
                <div>
                  <div class=" form-floating my-4 ">
                    <input
                      type="text"
                      class="form-control df-input"
                      id="product-title"
                      placeholder="title"
                      name="title"
                      value={selectedProduct.info.title}
                      readOnly
                    />
                    <p
                      className={`text-danger fs-12 ${
                        validationProduct.title == false ? "d-block" : "d-none"
                      }`}
                    >
                      این فیلد نمی تواند خالی باشد
                    </p>
                    <label for="product-title">عنوان کالا</label>
                  </div>
                  <div className="d-flex justify-content-between align-items-center flex-wrap pricestyle">
                    <div class=" form-floating mb-4 w-48">
                      <input
                        type="text"
                        class="form-control df-input"
                        id="product-price"
                        placeholder="price"
                        name="price"
                        value={addCommas(selectedProduct.info.price)}
                        onChange={e => {
                          inputChangeHandler(e, true);
                        }}
                      />
                      <p
                        className={`text-danger fs-12 ${
                          validationProduct.price == false
                            ? "d-block"
                            : "d-none"
                        }`}
                      >
                        این فیلد نمی تواند خالی باشد
                      </p>
                      <label for="product-price">قیمت(تومان)</label>
                    </div>
                    <div class="form-floating mb-4 w-48">
                      <input
                        type="text"
                        class="form-control df-input"
                        id="product-discount"
                        placeholder="discount"
                        name="priceWithDiscount"
                        value={addCommas(
                          selectedProduct.info.priceWithDiscount
                        )}
                        onChange={e => {
                          inputChangeHandler(e, true);
                          console.log(
                            "selectedproduct onChamnge:",
                            selectedProduct
                          );
                        }}
                      />

                      <label for="product-discount">
                        قیمت با تخفیف (تومان)
                      </label>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center flex-wrap pricestyle">
                    <div class="form-floating mb-4 w-48">
                      <input
                        type="text"
                        class="form-control df-input"
                        id="product-total_inventory_count"
                        placeholder="total_inventory_count"
                        name="total_inventory_count"
                        value={selectedProduct.info.total_inventory_count}
                        onChange={e => inputChangeHandler(e, true)}
                      />
                      <p
                        className={`text-danger fs-12 ${
                          validationProduct.inventory == false
                            ? "d-block"
                            : "d-none"
                        }`}
                      >
                        این فیلد نمی تواند خالی باشد
                      </p>
                      <label for="product-total_inventory_count">موجودی </label>
                    </div>

                    <div class="form-floating mb-4 w-48">
                      <input
                        type="text"
                        class="form-control df-input"
                        id="product-leastOrder"
                        placeholder="leastOrder"
                        name="min_order_count"
                        value={selectedProduct.info.min_order_count}
                        onChange={e => inputChangeHandler(e, true)}
                      />
                      <label for="product-leastOrder">حداقل سفارش</label>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-baseline flex-wrap pricestyle ">
                    <div class="form-floating mb-4 w-48">
                      <input
                        type="text"
                        class="form-control df-input"
                        id="product-weightFrom"
                        placeholder="weightFrom"
                        name="weight_from"
                        value={addCommas(selectedProduct.info.weight_from)}
                        onChange={e => inputChangeHandler(e, true)}
                      />

                      <label for="product-weightFrom">حداقل وزن (گرم)</label>
                    </div>
                    <div class="form-floating mb-4 w-48">
                      <input
                        type="text"
                        class="form-control df-input"
                        id="product-weightTo"
                        placeholder="weightTo"
                        name="weight_to"
                        value={addCommas(selectedProduct.info.weight_to)}
                        onChange={e => inputChangeHandler(e, true)}
                      />

                      <label for="product-weightTo">حداکثر وزن (گرم)</label>
                    </div>
                  </div>

                  <div className="product-options-container">
                    {selectedOption.map((value1, index) => {
                      return (
                        <div
                          key={`product-option-${index}`}
                          className="product-option flex-wrap"
                        >
                          <div className="d-flex">
                            <label class="switch">
                              <input
                                type="checkbox"
                                checked={value1.status}
                                key={index}
                                onChange={() =>
                                  setSelectedOption(prev => {
                                    let temp = [...prev];
                                    temp[index].status = !selectedOption[index]
                                      .status;
                                    return temp;
                                  })
                                }
                              />
                              <span class="slider round"></span>
                            </label>
                            <div className="mx-3">{value1.title}</div>
                          </div>
                          {value1.status && (
                            <div className="d-flex align-items-center  mt-1">
                              <input
                                type="text"
                                className="form-control product-option-input"
                                value={selectedOption[index].default_price}
                                onChange={e => {
                                  checkBoxHandler(index, e);

                                  console.log(
                                    "selectedOption2",
                                    e.target.value
                                  );
                                }}
                              />
                              <span>تومان</span>
                              <input
                                type="text"
                                className="form-control product-option-input"
                                style={{ width: "50px" }}
                                value={
                                  selectedOption[index].default_need_time / 60
                                }
                                onChange={e => checkBoxHandler1(index, e)}
                              />
                              <span>دقیقه</span>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  {/* ) */}
                  {/* } */}
                </div>
                <div className="w-100 d-flex justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-primary px-5 py-2 submit-btn"
                    id="editProductBtn"
                    onClick={e => {
                      console.log("sSss", setUpdater1);

                      e.preventDefault();
                      if (validation()) {
                        submitForm();
                      }
                    }}
                  >
                    ویرایش کالا
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
